export const ErrorBox = ({ message }: { message?: string }) => {
  return (
    <div className="text-redDark bg-redLight p-2 mx-10">
      {message || "An error has occurred"}
    </div>
  )
}
